import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-radioff",
  "use": "icon-radioff-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-radioff\"><path d=\"M477.3 190.3l-39.6 39.6-45.9-45.9c-24.6-1.6-31.2 21-19.8 32.4l39.6 39.6-45.9 45.9c-1.6 24.6 21 31.2 32.4 19.8l39.6-39.6 45.9 45.9c24.6 1.6 31.2-21 19.8-32.4L463.8 256l45.9-45.9c1.5-24.6-21-31.2-32.4-19.8zM297.5 18.7c-5.9-2.8-12.9-2.1-18.1 2l-166 132.8H34.1C15.3 153.6 0 168.9 0 187.7v136.5c0 18.8 15.3 34.1 34.1 34.1h79.3l166 132.8c3.1 2.5 6.9 3.7 10.7 3.7 2.5 0 5.1-.6 7.4-1.7 5.9-2.8 9.7-8.8 9.7-15.4V34.1c0-6.5-3.8-12.5-9.7-15.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol